
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { JobSearchFormData, jobSearchFormSchema } from '@/components/job-search/JobSearchFormSchema';
import { JobSearchCriteria } from '@/types/jobSearch';
import { useEffect } from 'react';

export const useJobSearchForm = (
  onSubmit: (criteria: JobSearchCriteria, providerId: string) => void,
  initialCriteria?: JobSearchCriteria
) => {
  const form = useForm<JobSearchFormData>({
    resolver: zodResolver(jobSearchFormSchema),
    defaultValues: {
      industry: initialCriteria?.industry || '',
      jobRole: initialCriteria?.jobRole || '',
      geography: initialCriteria?.geography || '',
      keywords: initialCriteria?.keywords || '',
      maxPostedWeeks: initialCriteria?.maxPostedWeeks || undefined,
      providerId: 'lutra-webhook',
    },
  });

  // Update form when initialCriteria changes
  useEffect(() => {
    if (initialCriteria) {
      form.reset({
        industry: initialCriteria.industry || '',
        jobRole: initialCriteria.jobRole || '',
        geography: initialCriteria.geography || '',
        keywords: initialCriteria.keywords || '',
        maxPostedWeeks: initialCriteria.maxPostedWeeks || undefined,
        providerId: form.getValues('providerId') || 'lutra-webhook',
      });
    }
  }, [initialCriteria, form]);

  const handleSubmit = (data: JobSearchFormData) => {
    console.log('[useJobSearchForm] Form data being submitted:', JSON.stringify(data, null, 2));
    
    const criteria: JobSearchCriteria = {
      industry: data.industry,
      jobRole: data.jobRole, // This should map correctly to jobRole in criteria
      geography: data.geography,
      keywords: data.keywords,
      maxPostedWeeks: data.maxPostedWeeks,
    };

    console.log('[useJobSearchForm] Criteria being passed to onSubmit:', JSON.stringify(criteria, null, 2));
    onSubmit(criteria, data.providerId);
  };

  return {
    form,
    handleSubmit,
  };
};
